package com.shadowings.gero.presentation.screen

import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.navigation.NavController
import androidx.navigation.compose.rememberNavController
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.platform.LocalUriHandler
import com.shadowings.gero.data.lessons.chapter1.getUni_1QuizContent
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.CalendarPromptScreen
import com.shadowings.gero.domain.model.FeaturePollOption
import com.shadowings.gero.domain.model.FeaturePollScreen
import com.shadowings.gero.domain.model.FinalQuizScreen
import com.shadowings.gero.domain.model.ICountableQuiz
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.LessonIds
import com.shadowings.gero.domain.model.MultiPressContent
import com.shadowings.gero.domain.model.MultiSelectionContent
import com.shadowings.gero.domain.model.PhoneticKeyboardContent
import com.shadowings.gero.domain.model.ImageKeyboardContent
import com.shadowings.gero.domain.model.QuizComboFive
import com.shadowings.gero.domain.model.QuizLevelUp
import com.shadowings.gero.domain.model.QuizThreeErrors
import com.shadowings.gero.domain.model.ReviewPromptScreen
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.domain.model.StreakCelebrationScreen
import com.shadowings.gero.domain.model.TextTranslationContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.domain.model.WordSelectionContent
import com.shadowings.gero.domain.model.WordSpellingContent
import com.shadowings.gero.presentation.component.RightStatsColumn
import com.shadowings.gero.presentation.component.StatType
import com.shadowings.gero.presentation.component.TopBar
import com.shadowings.gero.presentation.component.quiz.CalendarPromptPageComposable
import com.shadowings.gero.presentation.component.quiz.FeaturePollPageComposable
import com.shadowings.gero.presentation.component.quiz.FinalQuizScreenComposable
import com.shadowings.gero.presentation.component.quiz.MonoliteralPhoneticQuiz
import com.shadowings.gero.presentation.component.quiz.ImageKeyboardQuiz
import com.shadowings.gero.presentation.component.quiz.MultiPressComposable
import com.shadowings.gero.presentation.component.quiz.MultiSelectionComposable
import com.shadowings.gero.presentation.component.quiz.NoHeartsScreen
import com.shadowings.gero.presentation.component.quiz.PhoneticSingleSelectionComposable
import com.shadowings.gero.presentation.component.quiz.QuizComboFiveComposable
import com.shadowings.gero.presentation.component.quiz.QuizHeader
import com.shadowings.gero.presentation.component.quiz.QuizLevelUpComposable
import com.shadowings.gero.presentation.component.quiz.QuizThreeErrorsComposable
import com.shadowings.gero.presentation.component.quiz.ReviewPromptPageComposable
import com.shadowings.gero.presentation.component.quiz.StreakCelebrationPageComposable
import com.shadowings.gero.presentation.component.quiz.TextTranslationComposable
import com.shadowings.gero.presentation.component.quiz.TrueFalseContentComposable
import com.shadowings.gero.presentation.component.quiz.WordSelectionComposable
import com.shadowings.gero.presentation.component.quiz.WordSpellingComposable
import com.shadowings.gero.presentation.model.HeartActions
import com.shadowings.gero.presentation.model.QuizEffect
import com.shadowings.gero.presentation.model.QuizUiState
import com.shadowings.gero.presentation.model.RewardedAdStatus
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.util.DeviceClass
import com.shadowings.gero.presentation.util.DevicePreviews
import com.shadowings.gero.presentation.util.rememberDeviceInfo
import com.shadowings.gero.presentation.viewmodel.QuizViewModel
import com.shadowings.gero.util.getRateAppUrl
import com.shadowings.gero.util.rememberCalendarEventLauncher
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.calendar_prompt_event_description
import gero.composeapp.generated.resources.calendar_prompt_event_title
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import kotlin.time.TimeMark
import kotlin.time.TimeSource

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Preview(name = "Small Screen (Low Height)", heightDp = 480, widthDp = 320, showBackground = true)
@Composable
fun QuizScreenPreview() {
    AppTheme {
        Surface {
            QuizScreenContent(
                uiState = QuizUiState(
                    lessonId = LessonIds.INTRO_HIEROGLYPHS,
                    quizList = getUni_1QuizContent(listOf(), listOf(), "it"),
                    userData = UserData()
                ),
                hiero = listOf(),
                onQuizCompleted = { _, _, _ -> },
                onAddExperience = {},
                heartActions = HeartActions({}),
                navController = rememberNavController()
            )
        }
    }
}

@Composable
fun QuizScreen(
    navController: NavController,
    purchaseFullVersion: () -> Unit,
    restoreFullVersionPurchases: () -> Unit,
    isFullVersionUnlocked: Boolean,
    isPurchaseReady: Boolean,
    watchAdForHearts: () -> Unit = {},
    adStatus: RewardedAdStatus = RewardedAdStatus.LOADING,
    viewModel: QuizViewModel = koinViewModel(),
) {
    val uiState by viewModel.uiState.collectAsStateWithLifecycle()
    val uriHandler = LocalUriHandler.current
    val addToCalendar = rememberCalendarEventLauncher()
    val calendarEventTitle = stringResource(Res.string.calendar_prompt_event_title)
    val calendarEventDescription = stringResource(Res.string.calendar_prompt_event_description)

    val heartActions = remember(
        isFullVersionUnlocked,
        isPurchaseReady,
        adStatus,
        purchaseFullVersion,
        restoreFullVersionPurchases,
        watchAdForHearts,
    ) {
        HeartActions(
            removeOne = { isCorrect ->
                // No heart cost during "Correggi" — it's a low-stakes correction drill, not a
                // regular lesson quiz.
                if (!isFullVersionUnlocked && uiState.lessonId != LessonIds.CORRECTION) {
                    viewModel.removeHearts(isCorrect)
                }
            },
            buyFullVersion = purchaseFullVersion,
            restoreFullVersion = restoreFullVersionPurchases,
            watchAdForHearts = watchAdForHearts,
            isFullVersionUnlocked = isFullVersionUnlocked,
            isPurchaseReady = isPurchaseReady,
            adStatus = adStatus,
        )
    }

    val hieros = viewModel.hieros

    if (uiState.quizList.isNotEmpty()) {
        QuizScreenContent(
            uiState = uiState,
            hiero = hieros,
            onQuizCompleted = { stars, total, errors ->
                viewModel.onQuizCompleted(
                    stars,
                    total,
                    errors
                )
            },
            onAddExperience = { amount -> viewModel.addExperience(amount) },
            heartActions = heartActions,
            navController = navController,
            onReviewPromptAccepted = {
                viewModel.onReviewPromptAccepted()
                try {
                    uriHandler.openUri(getRateAppUrl())
                } catch (e: Exception) {
                    println("Failed to open rating page: ${e.message}")
                }
            },
            onCalendarPromptAccepted = { hour, minute ->
                viewModel.onCalendarPromptAccepted()
                addToCalendar(calendarEventTitle, calendarEventDescription, hour, minute)
            },
            onCalendarPromptDismissed = { viewModel.onCalendarPromptDismissed() },
            onFeaturePollSubmitted = { option, freeText -> viewModel.onFeaturePollSubmitted(option, freeText) },
            onStatClick = { stat ->
                viewModel.logStatClicked(stat.name)
                if (stat == StatType.STRIKE) viewModel.acknowledgeStreakRestorationBadge()
            },
            onGrantStreakRestorationTokens = { level -> viewModel.grantStreakRestorationTokensUpTo(level) },
            onRedeemStreakRestoration = { dateStr -> viewModel.redeemStreakRestoration(dateStr) },
            onAnswerResult = { isCorrect, record ->
                if (isCorrect) viewModel.resolveWrongAnswer(record.id) else viewModel.recordWrongAnswer(record)
            },
            effects = viewModel.effects,
            quizListState = viewModel.quizListState,
            quizResultsState = viewModel.quizResultsState,
            comboCount = viewModel.comboCount,
            errorsCount = viewModel.errorsCount,
            comboFiveRewards = viewModel.comboFiveRewards,
            correctAnswersCount = viewModel.correctAnswersCount,
            correctionLessonIdByContentId = viewModel.correctionLessonIdByContentId.value
        )
    } else {
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.Center
        ) {
            CircularProgressIndicator()
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun QuizScreenContent(
    uiState: QuizUiState,
    hiero: List<Hiero>,
    onQuizCompleted: (stars: Int, total: Int, errors: Int) -> Unit,
    onAddExperience: (Int) -> Unit,
    heartActions: HeartActions,
    navController: NavController,
    onReviewPromptAccepted: () -> Unit = {},
    onCalendarPromptAccepted: (hour: Int, minute: Int) -> Unit = { _, _ -> },
    onCalendarPromptDismissed: () -> Unit = {},
    onFeaturePollSubmitted: (option: FeaturePollOption, freeText: String) -> Unit = { _, _ -> },
    onStatClick: (StatType) -> Unit = {},
    onGrantStreakRestorationTokens: (Int) -> Unit = {},
    onRedeemStreakRestoration: (String) -> Unit = {},
    onAnswerResult: (isCorrect: Boolean, record: com.shadowings.gero.domain.model.WrongAnswerRecord) -> Unit = { _, _ -> },
    effects: kotlinx.coroutines.flow.Flow<QuizEffect> = kotlinx.coroutines.flow.emptyFlow(),
    quizListState: MutableState<List<IQuizContent>> = remember(uiState.quizList) {
        mutableStateOf(
            uiState.quizList
        )
    },
    quizResultsState: MutableState<Map<String, Boolean>> = remember { mutableStateOf(mapOf()) },
    comboCount: MutableState<Int> = remember { mutableStateOf(0) },
    errorsCount: MutableState<Int> = remember { mutableStateOf(0) },
    comboFiveRewards: MutableState<Int> = remember { mutableStateOf(0) },
    correctAnswersCount: MutableState<Int> = remember { mutableStateOf(0) },
    correctionLessonIdByContentId: Map<String, String> = emptyMap()
) {
    val userData = uiState.userData
    val testMode = uiState.isTestMode
    val hideOptions = uiState.hideOptions
    val hasAvailableStreakRestoration = userData.streakRestorationTokens.values.any { !it } &&
        !userData.streakRestorationBadgeSeen

    val deviceInfo = rememberDeviceInfo()
    val isWebFull = deviceInfo.deviceClass == DeviceClass.WEB_FULL
    val coroutineScope = rememberCoroutineScope()

    val pagerState = rememberPagerState(0) { quizListState.value.size }

    // Whether the streak/review pages exist at all is decided once in QuizViewModel.init, when
    // the page list is built — so advancing past any of them (including FinalQuizScreen) is
    // always just "move to the next already-existing page, or finish".
    val advanceOrFinish: () -> Unit = {
        if (pagerState.currentPage < quizListState.value.size - 1) {
            coroutineScope.launch { pagerState.animateScrollToPage(pagerState.currentPage + 1) }
        } else {
            navController.popBackStack()
        }
    }

    val quizStartMarkHolder = remember { mutableStateOf<TimeMark?>(null) }

    LaunchedEffect(Unit) {
        if (quizStartMarkHolder.value == null) {
            quizStartMarkHolder.value = TimeSource.Monotonic.markNow()
        }
    }


    // Tracks XP earned so far this quiz session on top of a fixed experienceBaseline captured
    // once at quiz start. We deliberately do NOT read the live userData.experience here: it only
    // catches up asynchronously after each addExperience() write lands, and since it keeps
    // increasing as those writes land, mixing it with sessionXpAwarded (which already counts
    // every grant since the start of the session) double-counts every write that has round-tripped
    // by the time the next one is checked — see git history/PR discussion for the bug this fixed.
    // A level-up page is spliced into the pager with the same "add(page + 1, ...)" pattern
    // QuizComboFive uses (see QuizPageState.onConfirm), just triggered from here instead, since XP
    // (unlike combo streaks) isn't tracked per-page.
    val experienceBaseline = remember { userData.experience }
    val sessionXpAwarded = remember { mutableStateOf(0) }
    // persist = false is for XP the ViewModel has already written (QuizEffect.ExperienceGranted):
    // only the session tally and the level-up splice are updated here.
    val addExperienceAndCheckLevelUp: (Int, Boolean) -> Unit = { amount, persist ->
        val levelBefore = com.shadowings.gero.domain.model.GameConstants.getPlayerLevel(
            experienceBaseline + sessionXpAwarded.value
        )
        sessionXpAwarded.value += amount
        val levelAfter = com.shadowings.gero.domain.model.GameConstants.getPlayerLevel(
            experienceBaseline + sessionXpAwarded.value
        )
        if (persist) onAddExperience(amount)
        println(
            "[LevelUp] addExperience amount=$amount baseline=$experienceBaseline " +
                "sessionXp=${sessionXpAwarded.value} levelBefore=$levelBefore levelAfter=$levelAfter " +
                "currentPage=${pagerState.currentPage} listSize=${quizListState.value.size}"
        )
        if (levelAfter > levelBefore) {
            onGrantStreakRestorationTokens(levelAfter)
            quizListState.value = quizListState.value.toMutableList()
                .apply {
                    add(
                        pagerState.currentPage + 1,
                        QuizLevelUp(level = levelAfter, tokensGranted = levelAfter - levelBefore)
                    )
                }
            println(
                "[LevelUp] inserted QuizLevelUp(level=$levelAfter) at index=${pagerState.currentPage + 1}, " +
                    "new listSize=${quizListState.value.size}"
            )
        }
    }

    LaunchedEffect(quizResultsState.value) {
        val currentCorrect = quizResultsState.value.values.count { it }
        if (currentCorrect > correctAnswersCount.value) {
            val diff = currentCorrect - correctAnswersCount.value
            addExperienceAndCheckLevelUp(diff, true)
            correctAnswersCount.value = currentCorrect
        } else if (currentCorrect < correctAnswersCount.value) {
            correctAnswersCount.value = currentCorrect
        }
    }

    // Handles the ViewModel's one-shot QuizEffects, moved here (rather than in the parent
    // QuizScreen) because ExperienceGranted needs addExperienceAndCheckLevelUp, which only exists
    // in this scope (it needs pagerState/quizListState to splice the level-up page).
    LaunchedEffect(Unit) {
        effects.collect { effect ->
            when (effect) {
                QuizEffect.NavigateBack -> navController.popBackStack()
                is QuizEffect.ExperienceGranted -> {
                    println("[LevelUp] ExperienceGranted effect received amount=${effect.amount}")
                    addExperienceAndCheckLevelUp(effect.amount, false)
                }
                is QuizEffect.NavigateToPage -> {}
            }
        }
    }

    val activeStatExplanation = remember { mutableStateOf<StatType?>(null) }

    Box(modifier = Modifier.fillMaxSize()) {
        BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
            val isLandscape = maxWidth > maxHeight

            Row(modifier = Modifier.fillMaxSize()) {
                Scaffold(
                    modifier = Modifier.weight(1f),
                    topBar = {
                        if (isWebFull) {
                            TopBar(
                                strikeCount = userData.strike,
                                level = com.shadowings.gero.domain.model.GameConstants.getPlayerLevel(
                                    userData.experience
                                ),
                                starCount = userData.stars.values.sum(),
                                heartsCount = if (heartActions.isFullVersionUnlocked) 999 else userData.hearts,
                                showHearts = !heartActions.isFullVersionUnlocked,
                                hasAvailableStreakRestoration = hasAvailableStreakRestoration,
                                onStatClick = { stat ->
                                    activeStatExplanation.value = stat
                                    onStatClick(stat)
                                },
                                onBackClick = { navController.popBackStack() }
                            )
                        } else if (!isLandscape) {
                            TopBar(
                                strikeCount = userData.strike,
                                level = com.shadowings.gero.domain.model.GameConstants.getPlayerLevel(
                                    userData.experience
                                ),
                                starCount = userData.stars.values.sum(),
                                heartsCount = if (heartActions.isFullVersionUnlocked) 999 else userData.hearts,
                                showHearts = !heartActions.isFullVersionUnlocked,
                                hasAvailableStreakRestoration = hasAvailableStreakRestoration,
                                onStatClick = { stat ->
                                    activeStatExplanation.value = stat
                                    onStatClick(stat)
                                }
                            )
                        }
                    },
                ) { padding ->
                    Box {
                        Column(
                            modifier = Modifier.fillMaxSize().padding(padding)
                                .then(if (isWebFull) Modifier.padding(64.dp) else Modifier)
                                .semantics { testTag = "quiz_screen" },
                            verticalArrangement = Arrangement.SpaceBetween,
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            QuizHeader(
                                quizList = quizListState.value,
                                currentPage = pagerState.currentPage,
                                quizResults = quizResultsState.value
                            )

                            HorizontalPager(
                                state = pagerState,
                                userScrollEnabled = false,
                                modifier = Modifier.weight(1f).fillMaxWidth()
                            ) { page ->
                                val quiz = quizListState.value[page]
                                // In correction mode every page can come from a different
                                // original lesson — fall back to the session lessonId ("correction")
                                // only when this content has no recorded mapping (e.g. special
                                // pages like FinalQuizScreen).
                                val pageLessonId = if (uiState.lessonId == LessonIds.CORRECTION) {
                                    (quiz as? ICountableQuiz)?.id
                                        ?.let { correctionLessonIdByContentId[it] }
                                        ?: uiState.lessonId
                                } else {
                                    uiState.lessonId
                                }
                                Box(
                                    modifier = Modifier.fillMaxSize()
                                        .semantics { testTag = "quiz_page_$page" }
                                ) {
                                    when (quiz) {
                                        is PhoneticKeyboardContent -> MonoliteralPhoneticQuiz(
                                            quizResults = quizResultsState,
                                            errorsCount = errorsCount,
                                            quiz = quiz,
                                            comboCount = comboCount,
                                            quizList = quizListState,
                                            page = page,
                                            pagerState = pagerState,
                                            navController = rememberNavController(),
                                            userData = userData,
                                            lessonId = pageLessonId,
                                            onComboFiveReached = {
                                                comboFiveRewards.value += 2
                                                addExperienceAndCheckLevelUp(2, true)
                                            },
                                            onNextQuestion = heartActions.removeOne,
                                            onAnswerResult = onAnswerResult,
                                            testMode = testMode
                                        )

                                        is ImageKeyboardContent -> ImageKeyboardQuiz(
                                            quizResults = quizResultsState,
                                            errorsCount = errorsCount,
                                            quiz = quiz,
                                            comboCount = comboCount,
                                            quizList = quizListState,
                                            page = page,
                                            pagerState = pagerState,
                                            navController = rememberNavController(),
                                            userData = userData,
                                            lessonId = pageLessonId,
                                            onComboFiveReached = {
                                                comboFiveRewards.value += 2
                                                addExperienceAndCheckLevelUp(2, true)
                                            },
                                            onNextQuestion = heartActions.removeOne,
                                            onAnswerResult = onAnswerResult,
                                            testMode = testMode
                                        )

                                        is FinalQuizScreen -> FinalQuizScreenComposable(
                                            quizResults = quizResultsState,
                                            isPerfect = uiState.lessonId != LessonIds.CORRECTION &&
                                                userData.stars[uiState.lessonId] == 3 && quizResultsState.value.values.all { it },
                                            isCorrection = uiState.lessonId == LessonIds.CORRECTION,
                                            availableCharacters = quiz.availableCharacters,
                                            quizStartMark = quizStartMarkHolder.value,
                                            comboFiveRewards = comboFiveRewards.value,
                                            navController = navController,
                                            userData = userData,
                                            isVisible = pagerState.currentPage == page,
                                            onQuizCompleted = onQuizCompleted,
                                            onContinue = advanceOrFinish
                                        )

                                        is StreakCelebrationScreen -> StreakCelebrationPageComposable(
                                            strikeCount = quiz.strikeCount,
                                            isVisible = pagerState.currentPage == page,
                                            onContinue = advanceOrFinish
                                        )

                                        is ReviewPromptScreen -> ReviewPromptPageComposable(
                                            userData = userData,
                                            onRateClick = {
                                                onReviewPromptAccepted()
                                                advanceOrFinish()
                                            },
                                            onDismiss = advanceOrFinish
                                        )

                                        is CalendarPromptScreen -> CalendarPromptPageComposable(
                                            userData = userData,
                                            onAddToCalendar = { hour, minute ->
                                                onCalendarPromptAccepted(hour, minute)
                                                advanceOrFinish()
                                            },
                                            onDismiss = {
                                                onCalendarPromptDismissed()
                                                advanceOrFinish()
                                            }
                                        )

                                        is FeaturePollScreen -> FeaturePollPageComposable(
                                            userData = userData,
                                            onSubmit = { option, freeText ->
                                                onFeaturePollSubmitted(option, freeText)
                                                advanceOrFinish()
                                            },
                                            onDismiss = advanceOrFinish
                                        )

                                        is TrueFalseContent -> TrueFalseContentComposable(
                                            quizResults = quizResultsState,
                                            errorsCount = errorsCount,
                                            quiz = quiz,
                                            comboCount = comboCount,
                                            quizList = quizListState,
                                            page = page,
                                            pagerState = pagerState,
                                            navController = rememberNavController(),
                                            testMode = testMode,
                                            hideOptions = hideOptions,
                                            userData = userData,
                                            lessonId = pageLessonId,
                                            onComboFiveReached = {
                                                comboFiveRewards.value += 2
                                                addExperienceAndCheckLevelUp(2, true)
                                            },
                                            onNextQuestion = heartActions.removeOne,
                                            onAnswerResult = onAnswerResult
                                        )

                                        is MultiSelectionContent -> MultiSelectionComposable(
                                            quizResults = quizResultsState,
                                            errorsCount = errorsCount,
                                            quiz = quiz,
                                            comboCount = comboCount,
                                            quizList = quizListState,
                                            page = page,
                                            pagerState = pagerState,
                                            navController = rememberNavController(),
                                            testMode = testMode,
                                            userData = userData,
                                            lessonId = pageLessonId,
                                            onComboFiveReached = {
                                                comboFiveRewards.value += 2
                                                addExperienceAndCheckLevelUp(2, true)
                                            },
                                            onNextQuestion = heartActions.removeOne
                                        )

                                        is MultiPressContent -> MultiPressComposable(
                                            quizResults = quizResultsState,
                                            errorsCount = errorsCount,
                                            quiz = quiz,
                                            comboCount = comboCount,
                                            quizList = quizListState,
                                            page = page,
                                            pagerState = pagerState,
                                            navController = rememberNavController(),
                                            userData = userData,
                                            lessonId = pageLessonId,
                                            onComboFiveReached = {
                                                comboFiveRewards.value += 2
                                                addExperienceAndCheckLevelUp(2, true)
                                            },
                                            onNextQuestion = heartActions.removeOne
                                        )

                                        is SingleSelectionContent -> PhoneticSingleSelectionComposable(
                                            quizResults = quizResultsState,
                                            errorsCount = errorsCount,
                                            quiz = quiz,
                                            comboCount = comboCount,
                                            quizList = quizListState,
                                            page = page,
                                            pagerState = pagerState,
                                            navController = rememberNavController(),
                                            testMode = testMode,
                                            hideOptions = hideOptions,
                                            userData = userData,
                                            lessonId = pageLessonId,
                                            onComboFiveReached = {
                                                comboFiveRewards.value += 2
                                                addExperienceAndCheckLevelUp(2, true)
                                            },
                                            onNextQuestion = heartActions.removeOne,
                                            onAnswerResult = onAnswerResult
                                        )

                                        is QuizComboFive -> QuizComboFiveComposable(
                                            quizList = quizListState,
                                            page = page,
                                            pagerState = pagerState,
                                            userData = userData,
                                            navController = navController
                                        )

                                        is QuizThreeErrors -> QuizThreeErrorsComposable(
                                            quizList = quizListState,
                                            page = page,
                                            pagerState = pagerState,
                                            navController = navController,
                                            userData = userData,
                                        )

                                        is QuizLevelUp -> QuizLevelUpComposable(
                                            level = quiz.level,
                                            tokensGranted = quiz.tokensGranted,
                                            quizList = quizListState,
                                            page = page,
                                            pagerState = pagerState,
                                            userData = userData,
                                            navController = navController
                                        )

                                        is WordSelectionContent -> WordSelectionComposable(
                                            quizResults = quizResultsState,
                                            errorsCount = errorsCount,
                                            quiz = quiz,
                                            comboCount = comboCount,
                                            quizList = quizListState,
                                            page = page,
                                            pagerState = pagerState,
                                            navController = rememberNavController(),
                                            testMode = testMode,
                                            hideOptions = hideOptions,
                                            userData = userData,
                                            lessonId = pageLessonId,
                                            onComboFiveReached = {
                                                comboFiveRewards.value += 2
                                                addExperienceAndCheckLevelUp(2, true)
                                            },
                                            onNextQuestion = heartActions.removeOne,
                                            onAnswerResult = onAnswerResult
                                        )

                                        is TextTranslationContent -> TextTranslationComposable(
                                            quizResults = quizResultsState,
                                            errorsCount = errorsCount,
                                            quiz = quiz,
                                            comboCount = comboCount,
                                            quizList = quizListState,
                                            page = page,
                                            pagerState = pagerState,
                                            navController = rememberNavController(),
                                            testMode = testMode,
                                            userData = userData,
                                            lessonId = pageLessonId,
                                            onComboFiveReached = {
                                                comboFiveRewards.value += 2
                                                addExperienceAndCheckLevelUp(2, true)
                                            },
                                            onNextQuestion = heartActions.removeOne,
                                            onAnswerResult = onAnswerResult
                                        )

                                        is WordSpellingContent -> WordSpellingComposable(
                                            quizResults = quizResultsState,
                                            errorsCount = errorsCount,
                                            quiz = quiz,
                                            comboCount = comboCount,
                                            quizList = quizListState,
                                            page = page,
                                            pagerState = pagerState,
                                            navController = rememberNavController(),
                                            testMode = testMode,
                                            hideOptions = hideOptions,
                                            userData = userData,
                                            lessonId = pageLessonId,
                                            onComboFiveReached = {
                                                comboFiveRewards.value += 2
                                                addExperienceAndCheckLevelUp(2, true)
                                            },
                                            onNextQuestion = heartActions.removeOne,
                                            onAnswerResult = onAnswerResult
                                        )
                                    }
                                }
                            }
                        }
                        val totalQuestions =
                            quizListState.value.filterIsInstance<ICountableQuiz>().size
                        val answeredQuestions = quizResultsState.value.keys.size
                        val remainingQuestions = totalQuestions - answeredQuestions

                        androidx.compose.animation.AnimatedVisibility(
                            // "Correggi" doesn't cost hearts (see HeartActions.removeOne), so it must stay
                            // playable even at 0 hearts.
                            visible = userData.hearts < 1 && remainingQuestions > 0 &&
                                !heartActions.isFullVersionUnlocked &&
                                uiState.lessonId != LessonIds.CORRECTION,
                            enter = fadeIn(
                                animationSpec = tween(durationMillis = 150)
                            ),
                            exit = fadeOut(
                                animationSpec = tween(durationMillis = 150)
                            )
                        ) {
                            NoHeartsScreen(
                                userData = userData,
                                heartActions = heartActions,
                                onDismiss = { navController.popBackStack() },
                            )
                        }
                    }
                }
                if (isLandscape && !isWebFull) {
                    RightStatsColumn(
                        strikeCount = userData.strike,
                        level = com.shadowings.gero.domain.model.GameConstants.getPlayerLevel(
                            userData.experience
                        ),
                        starCount = userData.stars.values.sum(),
                        heartsCount = if (heartActions.isFullVersionUnlocked) 999 else userData.hearts,
                        showHearts = !heartActions.isFullVersionUnlocked,
                        hasAvailableStreakRestoration = hasAvailableStreakRestoration,
                        onStatClick = { stat ->
                            activeStatExplanation.value = stat
                            onStatClick(stat)
                        }
                    )
                }
            }
        }

        activeStatExplanation.value?.let { statType ->
            StatExplanationBottomSheet(
                statType = statType,
                userData = userData,
                onDismiss = { activeStatExplanation.value = null },
                isFullVersionUnlocked = heartActions.isFullVersionUnlocked,
                onPurchaseFullVersion = heartActions.buyFullVersion,
                onRedeemStreakRestoration = onRedeemStreakRestoration
            )
        }
    }
}
